import { useEffect, useState } from "react";

interface CountdownTimerProps {
  /** Hours from now until offer ends. Defaults to a rolling 24h window. */
  hoursFromNow?: number;
}

const getEndTime = (hours: number) => {
  const stored = localStorage.getItem("offer_end_time");
  if (stored) {
    const end = parseInt(stored, 10);
    if (end > Date.now()) return end;
  }
  const end = Date.now() + hours * 60 * 60 * 1000;
  localStorage.setItem("offer_end_time", String(end));
  return end;
};

export const CountdownTimer = ({ hoursFromNow = 24 }: CountdownTimerProps) => {
  const [end] = useState(() => getEndTime(hoursFromNow));
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const diff = Math.max(0, end - now);
  const hrs = Math.floor(diff / (1000 * 60 * 60));
  const mins = Math.floor((diff / (1000 * 60)) % 60);
  const secs = Math.floor((diff / 1000) % 60);

  const Box = ({ value, label }: { value: number; label: string }) => (
    <div className="flex flex-col items-center">
      <div className="grid h-14 w-14 md:h-16 md:w-16 place-items-center rounded-2xl bg-foreground text-background font-display text-2xl md:text-3xl font-bold tabular-nums">
        {String(value).padStart(2, "0")}
      </div>
      <span className="mt-1.5 text-[10px] uppercase tracking-wider text-muted-foreground">
        {label}
      </span>
    </div>
  );

  return (
    <div className="flex items-center gap-2 md:gap-3">
      <Box value={hrs} label="Hours" />
      <span className="font-display text-2xl text-muted-foreground">:</span>
      <Box value={mins} label="Min" />
      <span className="font-display text-2xl text-muted-foreground">:</span>
      <Box value={secs} label="Sec" />
    </div>
  );
};
